import React, { createContext, useState, useEffect, useCallback } from 'react';
import StorageService from '../services/StorageService';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // Initialize auth state from localStorage
  useEffect(() => {
    const loginData = StorageService.loginData();
    const token = localStorage.getItem('token');

    if (loginData && token) {
      setUser(loginData);
      setIsAuthenticated(true);
    }
    setLoading(false);
  }, []);

  // Login function
  const login = useCallback((loginData, token) => {
    localStorage.setItem('token', token);
    StorageService.setLoginData(loginData);
    setUser(loginData);
    setIsAuthenticated(true);
  }, []);

  // Logout function
  const logout = useCallback((reason = 'logout') => {
    localStorage.removeItem('token');
    StorageService.clearLoginData();
    setUser(null);
    setIsAuthenticated(false);
    
    // Store logout reason for display if needed
    if (reason === 'token-expired') {
      localStorage.setItem('logoutReason', 'Token expired. Please login again.');
    }
  }, []);

  return (
    <AuthContext.Provider value={{
      user,
      loading,
      isAuthenticated,
      login,
      logout
    }}>
      {children}
    </AuthContext.Provider>
  );
};

// Custom hook to use auth context
export const useAuth = () => {
  const context = React.useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};
